import { render, staticRenderFns } from "./NewsDimensionRow.vue?vue&type=template&id=a1e7e276"
import script from "./NewsDimensionRow.vue?vue&type=script&lang=js"
export * from "./NewsDimensionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports